module.exports = __webpack_public_path__ + "assets/img/help_pagination02-1.8242b006.svg";